import React, { useState } from "react";
import LinkButton from "../universal/linkButton";
import DialogueMenu from "../universal/dialogueMenu";
import dialogues from "../../utils/dialogues";
import useCheckPlaceAccess from "../hooks/useCheckPlaceAccess";
import useChangeGameStatus from "../hooks/useChangeGameStatus";
import { useDispatch, useSelector } from "react-redux";
import { navbarBgChanged } from "../../store/game";
import { expAdded, itemsGiven, freeItemsAdded } from "../../store/auth";
import HeaderWithLogo from "../universal/headerWithLogo";
import Header from "../universal/header";
import ModalWindow from "../universal/modal";
import mine_webp from "../../images/mine.webp";
import mine_png from "../../images/mine.png";
import "../../App.css";
import "./mine.css";

const Mine = () => {
  useCheckPlaceAccess("mine");
  useChangeGameStatus();

  const dispatch = useDispatch();

  const { currentPlanet, inventory } = useSelector((state) =>
    state.user.auth.currentUser
      ? state.user.auth.currentUser.progress
      : {
          currentPlanet: null,
          inventory: [],
        }
  );
  const credits = inventory?.credits;

  const placeDescription =
    "Both those who want to earn some extra money with hard work and those who have been forced to work for minor offenses are staying here. Mine managers charge a small fee for the possibility of digging.";

  const [modalTrigger, setModalTrigger] = useState(false);
  const [summary, setSummary] = useState([]);

  const toggleModal = () => {
    setModalTrigger(!modalTrigger);
  };

  const mine = () => {
    if (credits >= 500) {
      const founds = {};

      // rate
      const rate = {
        creditsRate: 0,
        steelRate: 0,
        aluminumRate: 0,
        stardustRate: 0,
      };

      // if found
      const ifCredits = [0, 0, 0, 1];
      const ifSteel = [0, 0, 1];
      const ifAluminum = [0, 0, 0, 1];
      const ifStardust = [0, 0, 0, 0, 0, 0, 1];

      // checks if something is found
      const foundCredits =
        ifCredits[Math.floor(Math.random() * ifCredits.length)];
      const foundSteel = ifSteel[Math.floor(Math.random() * ifSteel.length)];
      const foundAluminum =
        ifAluminum[Math.floor(Math.random() * ifAluminum.length)];
      const foundStardust =
        ifStardust[Math.floor(Math.random() * ifStardust.length)];

      if (foundCredits) {
        rate.creditsRate = Math.floor(Math.random() * 1000) + 1;
        founds["credits"] = rate.creditsRate;
      }
      if (foundSteel) {
        rate.steelRate = Math.floor(Math.random() * 3) + 1;
        founds["steel"] = rate.steelRate;
      }
      if (foundAluminum) {
        rate.aluminumRate = Math.floor(Math.random() * 2) + 1;
        founds["aluminum"] = rate.aluminumRate;
      }
      if (foundStardust) {
        rate.stardustRate = Math.floor(Math.random() * 1) + 1;
        founds["stardust"] = rate.stardustRate;
      }

      dispatch(itemsGiven({ give: { credits: 500 } }));

      if (founds) {
        dispatch(
          freeItemsAdded({
            credits: rate.creditsRate,
            steel: rate.steelRate,
            aluminum: rate.aluminumRate,
            stardust: rate.stardustRate,
          })
        );

        const len = Object.keys(founds).length;
        if (len > 0) {
          const exp = 100 * len;
          dispatch(expAdded(exp));
        }
      }

      mineSummary(founds);
      toggleModal();
    } else {
      alert("Not enough credits [!]");
    }
  };

  const mineSummary = (object) => {
    const items = [];
    for (let [item, amount] of Object.entries(object)) {
      items.push([item, amount]);
    }
    setSummary(items);
  };

  const displayCredits = (element) => {
    return element === "credits" ? "[!]" : element;
  };

  const renderSummary = () => {
    if (summary.length !== 0) {
      return summary.map((element) => (
        <li className="color-win" key={element[0]}>
          +{element[1]} {displayCredits(element[0])}
        </li>
      ));
    } else {
      return <p className="color-lose">Nothing found</p>;
    }
  };

  const renderMineButton = () => {
    if (credits >= 500) {
      return (
        <button className="button small" onClick={mine}>
          mine - 500[!]
        </button>
      );
    } else {
      return (
        <button className="button small">Not enough credits - 500[!]</button>
      );
    }
  };

  return (
    <main
      className="mine-wrapper flex-auto main-wrapper"
      onScroll={(e) => dispatch(navbarBgChanged(e.currentTarget.scrollTop))}
    >
      <section id="mine" className="mine-header-container">
        <HeaderWithLogo
          headerSize={"h2"}
          header={"mine"}
          text={placeDescription}
          webp={mine_webp}
          png={mine_png}
          size={"150em"}
          alt={
            "A large chunk of rock with pink crystal fragments stuck in it. A mine logo."
          }
        />
        <section>
          <Header headerSize={"h3"} header={"work"} underline />
          <article className="section-split margin-bottom-2rem">
            <article className="align-self-flex-start">
              <Header headerSize={"h4"} header={"available credits"} />
              <p>{credits}</p>
              <ul>{renderMineButton()}</ul>
            </article>
          </article>
        </section>
        <section>
          <Header headerSize={"h3"} header={"talk"} underline />
          <article>
            <Header headerSize={"h4"} header={"miner"} />
            {dialogues[currentPlanet].length !== 0 && (
              <DialogueMenu place={"mine"} />
            )}
          </article>
        </section>
        <LinkButton destination={currentPlanet} title={"walk away"} />
      </section>
      <ModalWindow
        isOpen={modalTrigger}
        onRequestClose={toggleModal}
        contentLabel="Mine summary modal"
        content={renderSummary()}
      />
    </main>
  );
};

export default Mine;
